/**
 * 防抖
 * @param {function} fn
 * @param {number} time
 * @returns
 */
function debounce(fn, time) {
  var timer
  return function () {
    clearTimeout(timer)
    timer = setTimeout(fn, time)
  }
}
let viewport = document.querySelector('meta[name=viewport]')
console.log(viewport)
console.log(window.devicePixelRatio)
// if (window.devicePixelRatio == 1) {
//   viewport.setAttribute(
//     'content',
//     'width=device-width,initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no'
//   )
// }
// if (window.devicePixelRatio == 2) {
//   viewport.setAttribute(
//     'content',
//     'width=device-width,initial-scale=0.5, maximum-scale=0.5, minimum-scale=0.5, user-scalable=no'
//   )
// }
// if (window.devicePixelRatio == 3) {
//   viewport.setAttribute(
//     'content',
//     'width=device-width,initial-scale=0.3333333333333333, maximum-scale=0.3333333333333333, minimum-scale=0.3333333333333333, user-scalable=no'
//   )
// }
/**
 * 设置根字体大小，按照750px 设计宽度 rem 100，来计算
 */
const setFont = function () {
  const clientWidth = window.innerWidth || document.documentElement.clientWidth
  document.documentElement.style.fontSize = clientWidth / 10 + 'px'
  var computedFontSize = parseFloat(
    getComputedStyle(document.documentElement).fontSize
  )
  console.log('computedFontSize', computedFontSize)
  var configFontSize = parseFloat(document.documentElement.style.fontSize)
  console.log('configFontSize', configFontSize)
  document.documentElement.style.fontSize =
    (configFontSize * configFontSize) / computedFontSize + 'px'
}
document.addEventListener('DOMContentLoaded', function () {
  setFont()
})
// setFont()
var change = debounce(setFont, 200)
window.addEventListener('resize', function () {
  change()
})
